import { Component, ElementRef, Input } from '@angular/core';
import { UniquelyIdentifiable } from '../../../../../models/protocols/uniquely-identifiable';
import type { Section } from '../../../../../models/menu/section/section';
import { RenderContextComponent } from '../../../../../models/base/render-context-component';

@Component({
  selector: 'app-scrollable-item',
  template: '',
  standalone: false
})
export abstract class ScrollableItemComponent extends RenderContextComponent implements UniquelyIdentifiable {
  constructor(public element: ElementRef) {
    super();
  }

  abstract getUniqueIdentifier(...opts: any): string;

  @Input() section: Section;
}
